import { render, staticRenderFns } from "./LectureVideoCreate.vue?vue&type=template&id=47c97dc8&"
import script from "./LectureVideoCreate.vue?vue&type=script&lang=ts&"
export * from "./LectureVideoCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports